import React, { useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import authService from '../services/authService';

const ResetPassword = () => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (newPassword !== confirmPassword) {
      setError('Las contraseñas no coinciden.');
      return;
    }

    if (newPassword.length < 6) {
      setError('La contraseña debe tener al menos 6 caracteres.');
      return;
    }

    setLoading(true);

    try {
      const response = await authService.resetPassword(token, newPassword);
      alert(response.data?.message || 'Contraseña restablecida con éxito.');
      navigate('/');
    } catch (err) {
      console.error('Reset password error:', err);
      setError(err.response?.data?.message || 'El enlace es inválido o ha expirado.');
    } finally {
      setLoading(false);
    }
  };

  if (!token) {
    return (
      <div style={{ padding: '40px', textAlign: 'center' }}>
        <h2>Enlace no válido</h2>
        <p>No se encontró un token válido para restablecer la contraseña.</p>
        <button onClick={() => navigate('/')} style={{ color: '#007A33', fontWeight: 'bold', border: 'none', background: 'none', cursor: 'pointer', textDecoration: 'underline' }}>
          Ir al Login
        </button>
      </div>
    );
  }

  return (
    <div style={{ padding: '20px', fontFamily: 'sans-serif', backgroundColor: '#e6f0e9', minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <div style={{ textAlign: 'center', maxWidth: '450px', width: '100%' }}>
        <img src="/Logo-Andromeda.png" alt="Logo" style={{ width: '80px', marginBottom: '20px' }} />
        <div style={{ padding: '30px', border: '1px solid #e0e0e0', borderRadius: '8px', boxShadow: '0 4px 10px rgba(0,0,0,0.05)', backgroundColor: '#fff' }}>
          <h2 style={{ color: '#007A33', marginBottom: '20px' }}>Nueva Contraseña</h2>
          <p style={{ color: '#666', marginBottom: '25px', fontSize: '0.95em' }}>
            Elige una nueva contraseña segura para tu cuenta.
          </p>

          {error && (
            <div style={{ backgroundColor: '#fff1f0', border: '1px solid #ffa39e', color: '#cf1322', padding: '15px', borderRadius: '5px', marginBottom: '20px', fontSize: '0.9em', textAlign: 'left' }}>
              {error}
            </div>
          )}

          <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
            <input
              type="password"
              placeholder="Nueva contraseña"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              required
              disabled={loading}
              style={{ padding: '12px', fontSize: '1em', borderRadius: '5px', border: '1px solid #007A33' }}
            />
            <input
              type="password"
              placeholder="Confirmar contraseña"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              required
              disabled={loading}
              style={{ padding: '12px', fontSize: '1em', borderRadius: '5px', border: '1px solid #007A33' }}
            />
            <button
              type="submit"
              disabled={loading}
              style={{
                padding: '12px',
                fontSize: '1.1em',
                backgroundColor: '#007A33',
                color: 'white',
                border: 'none',
                borderRadius: '5px',
                cursor: 'pointer',
                fontWeight: 'bold',
                transition: 'opacity 0.3s'
              }}
            >
              {loading ? 'Procesando...' : 'Restablecer Contraseña'}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;